// useUploadPropertyPhoto.js - CORRECTED VERSION
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { authServices } from 'features/auth/services/auth.service';

export const useUploadPropertyPhoto = () => {
  return useMutation({
    mutationFn: async ({ file }) => {
      const uploadResponse = await authServices.uploadFile(file);

      // Extract from your API response structure
      const key = uploadResponse?.data?.key;
      const preSignedUrl = uploadResponse?.data?.preSignedUrl;

      if (!key || !preSignedUrl) {
        throw new Error('Failed to get photo data from upload response');
      }

      // Return both the key (for DB storage) and preSignedUrl (for preview)
      return { 
        key: key,               // S3 key to store in database
        preSignedUrl: preSignedUrl  // Pre-signed URL for immediate preview
      };
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to upload photo';
      toast.error(message);
    },
  });
};